module.exports = __webpack_public_path__ + "img/avatar.cc93a967.jpg";